module.exports = __webpack_public_path__ + "static/media/outsourcing.cc0fd0a0.svg";